import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import { MathHelper } from '../../../Utility/MathHelper';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';

const SLICES: number = 8;

export class WheelSpinComplete extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const pin = meta.pin.getComponent(ElementComponent);
        const slice = Math.floor((pin.rotation - Math.PI / 8) / (Math.PI / 4));

        meta.bright.getComponent(ElementComponent).rotation =
            ((slice * Math.PI) / 4) % (Math.PI * 2);
        const brightRenderable: Renderable = meta.bright.getComponent(
            Renderable
        );

        const curr = MathHelper.repeat(slice, SLICES);
        const next = MathHelper.repeat(slice + 1, SLICES);

        const bulbs: Renderable[] = [];
        meta.bulbs.forEach((bulb: GameObject) => {
            const renderable = bulb.getComponent(Renderable);
            renderable.alpha = 0;
            bulbs.push(renderable);
        });

        const flashBulbs = bulbs.filter(
            (bulb, index) => index === curr || index === next
        );

        /*
        bulbs.forEach((bulb, index) => {
            if (index === curr || index === next) {
                bulb.alpha = 1;
            } else {
                bulb.alpha = Math.max(0, bulb.alpha - 0.05);
            }
        });
        */

        while (true) {
            flashBulbs.forEach(bulb => (bulb.alpha = 1));
            brightRenderable.visible = true;
            yield* delay(200);
            brightRenderable.visible = false;
            flashBulbs.forEach(bulb => (bulb.alpha = 0.05));
            yield* delay(200);
        }
    }
}
